import React, { useState, useEffect } from 'react';
import { DataTable } from '../ui/data-table';
import { Button } from '../ui/button';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '../ui/modal';
import { Input } from '../ui/input';
import { examAPI, courseAPI, examQuestionAPI, quizAPI, questionAPI, userAPI, examAvailabilityAPI, classAPI, examTypeAPI, examUserRetakeAPI } from '../../services/api';

const Exams = () => {
  const [exams, setExams] = useState([]);
  const [courses, setCourses] = useState([]);
  const [examQuestions, setExamQuestions] = useState([]);
  const [quizzes, setQuizzes] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [selectedQuizzes, setSelectedQuizzes] = useState([]);
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const [users, setUsers] = useState([]);
  const [availabileUsers, setAvailableUsers] = useState([]);  
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);
  const [classes, setClasses] = useState([]);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [classesLoading, setClassesLoading] = useState(false);
  const [togglingRetakeUserId, setTogglingRetakeUserId] = useState(null);
  const [togglingRetakeClassTitle, setTogglingRetakeClassTitle] = useState(null);
  const [examTypes, setExamTypes] = useState([]);
  const [examTypesLoading, setExamTypesLoading] = useState(false);
  const [filteredExamTypes, setFilteredExamTypes] = useState([]);
  const [courseExamTypes, setCourseExamTypes] = useState([]);
  const [courseExamTypesLoading, setCourseExamTypesLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [coursesLoading, setCoursesLoading] = useState(false);
  const [questionsLoading, setQuestionsLoading] = useState(false);
  const [quizzesLoading, setQuizzesLoading] = useState(false);
  const [questionsDataLoading, setQuestionsDataLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isQuestionsModalOpen, setIsQuestionsModalOpen] = useState(false);
  const [isAddQuestionModalOpen, setIsAddQuestionModalOpen] = useState(false);
  const [isUserAvailabilityModalOpen, setIsUserAvailabilityModalOpen] = useState(false);
  const [isShowAvailableUsersModalOpen, setIsShowAvailableUsersModalOpen] = useState(false);
  const [isExamTypeModalOpen, setIsExamTypeModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingExamId, setEditingExamId] = useState(null);
  const [selectedExamId, setSelectedExamId] = useState(null);
  const [selectedExam, setSelectedExam] = useState(null);
  const [deletingExamId, setDeletingExamId] = useState(null);
  const [deletingExamQuestionId, setDeletingExamQuestionId] = useState(null);
  const [deletingExamTypeId, setDeletingExamTypeId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmittingQuestion, setIsSubmittingQuestion] = useState(false);
  const [isSubmittingAvailability, setIsSubmittingAvailability] = useState(false);
  const [isSubmittingExamType, setIsSubmittingExamType] = useState(false);
  const [examTypeFilterCourse, setExamTypeFilterCourse] = useState('');
  const [questionSearchQuery, setQuestionSearchQuery] = useState('');
  const [availableUsersSearchQuery, setAvailableUsersSearchQuery] = useState('');
  const [availabilityError, setAvailabilityError] = useState('');
  const [availabilityLoading, setAvailabilityLoading] = useState(false);
  const [availabilityRefresh, setAvailabilityRefresh] = useState(0);
  const [availableUsersClassFilter, setAvailableUsersClassFilter] = useState('');
  const [makeAvailableUsersSearchQuery, setMakeAvailableUsersSearchQuery] = useState('');
  const [examTypeFormData, setExamTypeFormData] = useState({
    name: '',
    description: '',
    course_id: ''
  });
  const [formData, setFormData] = useState({
    course_id: '',
    exam_type_id: '',
    title: '',
    description: '',
    total_marks: '',
    pass_marks: '',
    duration_minutes: '',
    is_active: false
  });

  const columns = [
    {
      accessorKey: 'id',
      header: 'ID',
      sortable: true
    },
    {
      accessorKey: 'title',
      header: 'Title',
      sortable: true
    },
    {
      accessorKey: 'description',
      header: 'Description',
      sortable: false,
      cell: (exam) => (
        <div title={exam.description}>
          {exam.description || 'No description'}
        </div>
      )
    },
    {
      accessorKey: 'course_title',
      header: 'Course',
      sortable: true,
      cell: (exam) => getCourseTitle(exam.course_id)
    },
    {
      accessorKey: 'total_marks',
      header: 'Total Marks',
      sortable: true
    },
    {
      accessorKey: 'pass_marks',
      header: 'Pass Marks',
      sortable: true
    },
    {
      accessorKey: 'duration_minutes',
      header: 'Duration (min)',
      sortable: true
    },
    {
      accessorKey: 'is_active',
      header: 'Status',
      sortable: true,
      cell: (exam) => (
        <div className="flex space-x-1">
          <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
            exam.is_active 
              ? 'bg-green-100 text-green-800' 
              : 'bg-gray-100 text-gray-800'
          }`}>
            {exam.is_active ? 'Active' : 'Inactive'}
          </span>
          <button
            onClick={() => handleToggleStatus(exam)}
            className="p-1 text-blue-500 hover:text-blue-700 hover:bg-blue-50 rounded transition-colors"
            title={exam.is_active ? 'Deactivate exam' : 'Activate exam'}
          >
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
            </svg>
          </button>
        </div>
      )
    },
    {
      accessorKey: 'created_at',
      header: 'Created At',
      sortable: true,
      cell: (row) => row.created_at ? new Date(row.created_at).toLocaleDateString() : 'N/A'
    },
    {
      accessorKey: 'actions',
      header: 'Actions',
      sortable: false,
      className: 'w-56',
      cell: (row) => (
        <div className="flex space-x-1">
          <button
            onClick={() => handleMakeUserAvailable(row)}
            className="p-1.5 text-orange-500 hover:text-orange-700 hover:bg-orange-50 rounded-full transition-colors"
            title="Make users available to take exam"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </button>
          <button
            onClick={() => handleShowUserAvailable(row)}
            className="p-1.5 text-green-500 hover:text-green-700 hover:bg-green-50 rounded-full transition-colors"
            title="Show users available to take exam"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
          </button>
          <button
            onClick={() => handleAddQuestion(row)}
            className="p-1.5 text-green-500 hover:text-green-700 hover:bg-green-50 rounded-full transition-colors"
            title="Add question to exam"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
          </button>
          <button
            onClick={() => handleSeeQuestions(row)}
            className="p-1.5 text-purple-500 hover:text-purple-700 hover:bg-purple-50 rounded-full transition-colors"
            title="View exam questions"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
          </button>
          <button
            onClick={() => handleEditExam(row)}
            className="p-1.5 text-blue-500 hover:text-blue-700 hover:bg-blue-50 rounded-full transition-colors"
            title="Edit exam"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
          </button>
          <button
            onClick={() => handleDeleteExam(row.id)}
            disabled={deletingExamId === row.id}
            className="p-1.5 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-full transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            title="Delete exam"
          >
            {deletingExamId === row.id ? (
              <div className="animate-spin w-4 h-4 border-2 border-red-500 border-t-transparent rounded-full"></div>
            ) : (
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            )}
          </button>
        </div>
      )
    }
  ];

    // Fetch exams
  const fetchExams = async () => {
    try {
      setLoading(true);
      const response = await examAPI.getAllExams();
      setExams(response.data);
    } catch (error) {
      console.error('Error fetching exams:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCourses = async () => {
    try {
      setCoursesLoading(true);
      const response = await courseAPI.getAllCourses();
      setCourses(response.data || []);
    } catch (error) {
      console.error('Error fetching courses:', error);
      setCourses([]);
    } finally {
      setCoursesLoading(false);
    }
  };

  const fetchQuizzes = async () => {
    try {
      setQuizzesLoading(true);
      const response = await quizAPI.getAllQuizzes();
      console.log('Fetched quizzes:', response.data);
      setQuizzes(response.data || []);
    } catch (error) {
      console.error('Error fetching quizzes:', error);
      setQuizzes([]);
    } finally {
      setQuizzesLoading(false);
    }
  };

  const fetchQuestions = async () => {
    try {
      setQuestionsDataLoading(true);
      const response = await questionAPI.getAllQuestions();
      console.log('Fetched questions:', response.data);
      setQuestions(response.data || []);
    } catch (error) {
      console.error('Error fetching questions:', error);
      setQuestions([]);
    } finally {
      setQuestionsDataLoading(false);
    }
  };

  const fetchUsers = async () => {
    try {
      setUsersLoading(true);
      const response = await userAPI.getAllUsers({ cache: 'no-store' });
      console.log('Fetched users:', response.data);
      setUsers(response.data || []);
    } catch (error) {
      console.error('Error fetching users:', error);
      setUsers([]);
    } finally {
      setUsersLoading(false);
    }
  };

  const fetchClasses = async () => {
    try {
      setClassesLoading(true);
      const response = await classAPI.getAllClasses({ cache: 'no-store' });
      console.log('Fetched classes:', response.data);
      setClasses(response.data || []);
    } catch (error) {
      console.error('Error fetching classes:', error);
      setClasses([]);
    } finally {
      setClassesLoading(false);
    }
  };

  const fetchExamTypes = async () => {
    try {
      setExamTypesLoading(true);
      const response = await examTypeAPI.getAllExamTypes();
      console.log('Fetched exam types:', response.data);
      setExamTypes(response.data || []);
      setFilteredExamTypes(response.data || []);
    } catch (error) {
      console.error('Error fetching exam types:', error);
      setExamTypes([]);
      setFilteredExamTypes([]);
    } finally {
      setExamTypesLoading(false);
    }
  };

  const fetchExamTypesByCourse = async (courseId) => {
    try {
      setCourseExamTypesLoading(true);
      const response = await examTypeAPI.getExamTypesByCourseId(courseId);
      console.log('Fetched exam types for course:', response.data);
      setCourseExamTypes(response.data || []);
    } catch (error) {
      console.error('Error fetching exam types for course:', error);
      setCourseExamTypes([]);
    } finally {
      setCourseExamTypesLoading(false);
    }
  };

  useEffect(() => {
    fetchExams();
    fetchCourses();
  }, []);

  // Ensure courses are loaded when modal opens
  useEffect(() => {
    if (isModalOpen) {
      fetchCourses();
    }
  }, [isModalOpen]);

  const handleInputChange = async (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    // When course changes, fetch exam types for that course
    if (name === 'course_id' && value) {
      await fetchExamTypesByCourse(value);
      // Reset exam type selection when course changes
      setFormData(prev => ({
        ...prev,
        exam_type_id: ''
      }));
    } else if (name === 'course_id' && !value) {
      // Clear exam types when no course is selected
      setCourseExamTypes([]);
      setFormData(prev => ({
        ...prev,
        exam_type_id: ''
      }));
    }
  };

  const handleAddQuestion = async (exam) => {
    setSelectedExam(exam);
    setSelectedExamId(exam.id);
    setIsAddQuestionModalOpen(true);
    setSelectedQuizzes([]);
    setSelectedQuestions([]);
    
    // Fetch quizzes and questions when modal opens
    await fetchQuizzes();
    await fetchQuestions();
  };

  const handleSeeQuestions = async (exam) => {
    try {
      setSelectedExam(exam);
      setSelectedExamId(exam.id);
      setQuestionsLoading(true);
      setIsQuestionsModalOpen(true);
      
      const response = await examQuestionAPI.getExamQuestionsByExamId(exam.id);
      console.log('Exam questions response:', response.data);
      setExamQuestions(response.data || []);
    } catch (error) {
      console.error('Error fetching exam questions:', error);
      setExamQuestions([]);
    } finally {
      setQuestionsLoading(false);
    }
  };

  const handleDeleteExamQuestion = async (examQuestionId) => {
    if (!window.confirm('Are you sure you want to remove this question/quiz from the exam?')) {
      return;
    }

    try {
      setDeletingExamQuestionId(examQuestionId);
      await examQuestionAPI.deleteExamQuestion(examQuestionId);
      
      // Refresh the exam questions list
      if (selectedExamId) {
        const response = await examQuestionAPI.getExamQuestionsByExamId(selectedExamId);
        console.log('Refreshed exam questions after delete:', response.data);
        setExamQuestions(response.data || []);
      }
      
      // Clear cache to ensure fresh data
      examQuestionAPI.clearExamQuestionCache();
      
    } catch (error) {
      console.error('Error deleting exam question:', error);
      alert('Failed to remove question from exam. Please try again.');
    } finally {
      setDeletingExamQuestionId(null);
    }
  };

  const handleSubmitQuestion = async (e) => {
    e.preventDefault();
    
    if (selectedQuizzes.length === 0 && selectedQuestions.length === 0) {
      alert('Please select at least one quiz or question.');
      return;
    }
    
    try {
      setIsSubmittingQuestion(true);
      
      // Create exam questions for selected quizzes (with question_id = 0)
      for (const quiz of selectedQuizzes) {
        const quizData = {
          exam_id: selectedExamId,
          quiz_id: quiz.id,
          question_id: 0
        };
        
        console.log('Creating exam question for quiz:', quizData);
        await examQuestionAPI.createExamQuestion(quizData);
      }
      
      // Create exam questions for selected questions (with quiz_id = 0 or empty)
      for (const question of selectedQuestions) {
        const questionData = {
          exam_id: selectedExamId,
          quiz_id: 0,
          question_id: question.id
        };
        
        console.log('Creating exam question for question:', questionData);
        await examQuestionAPI.createExamQuestion(questionData);
      }
      
      setIsAddQuestionModalOpen(false);
      setSelectedQuizzes([]);
      setSelectedQuestions([]);
      
      alert(`Successfully added ${selectedQuizzes.length} quizzes and ${selectedQuestions.length} questions to the exam!`);
      
      // Clear cache to ensure fresh data
      examQuestionAPI.clearExamQuestionCache();
      
    } catch (error) {
      console.error('Error creating exam questions:', error);
      alert('Failed to add questions to exam. Please try again.');
    } finally {
      setIsSubmittingQuestion(false);
    }
  };

  const handleSubmitUserAvailability = async (e) => {
    e.preventDefault();
    
    if (selectedUsers.length === 0 && selectedClasses.length === 0) {
      alert('Please select at least one user or class.');
      return;
    }
    
    try {
      setIsSubmittingAvailability(true);
      
      // Create exam availability for selected users
      for (const user of selectedUsers) {
        const availabilityData = {
          user_id: user.id,
          exam_id: selectedExamId
        };
        
        console.log('Creating exam availability for user:', availabilityData);
        await examAvailabilityAPI.createExamAvailability(availabilityData);
      }
      
      // Apply exam access to the currently enrolled students only.
      for (const classItem of selectedClasses) {
        await examAvailabilityAPI.createExamAvailability({
          class_id: classItem.id,
          exam_id: selectedExamId
        });
      }

      setIsUserAvailabilityModalOpen(false);
      setSelectedUsers([]);
      setSelectedClasses([]);
      
      alert(`Successfully made the exam available to ${selectedUsers.length} user(s) and ${selectedClasses.length} class(es)!`);
      
      // Clear cache to ensure fresh data
      examAvailabilityAPI.clearExamAvailabilityCache();
      
    } catch (error) {
      console.error('Error creating exam availability:', error);
      alert('Failed to make exam available. Please try again.');
    } finally {
      setIsSubmittingAvailability(false);
    }
  };

  const handleQuizSelection = (quiz) => {
    setSelectedQuizzes(prev => {
      const isSelected = prev.find(q => q.id === quiz.id);
      if (isSelected) {
        return prev.filter(q => q.id !== quiz.id);
      } else {
        return [...prev, quiz];
      }
    });
  };

  const handleQuestionSelection = (question) => {
    setSelectedQuestions(prev => {
      const isSelected = prev.find(q => q.id === question.id);
      if (isSelected) {
        return prev.filter(q => q.id !== question.id);
      } else {
        return [...prev, question];
      }
    });
  };

  const handleMakeUserAvailable = async (exam) => {
    setSelectedExam(exam);
    setSelectedExamId(exam.id);
    setIsUserAvailabilityModalOpen(true);
    setSelectedUsers([]);
    setSelectedClasses([]);
    
    setMakeAvailableUsersSearchQuery('');

    // Fetch users and classes when modal opens
    await Promise.all([fetchUsers(), fetchClasses()]);
  };

  const handleShowUserAvailable = (exam) => {
    setSelectedExam(exam);
    setSelectedExamId(exam.id);
    setAvailableUsers([]);
    setAvailableUsersSearchQuery('');
    setAvailableUsersClassFilter('');
    setIsShowAvailableUsersModalOpen(true);
  };

  useEffect(() => {
    if (!isShowAvailableUsersModalOpen || !selectedExamId) return;
    let active = true;
    let pending = false;
    const refresh = async () => {
      if (pending) return;
      pending = true;
      setAvailabilityLoading(true);
      try {
        const response = await examAvailabilityAPI.getExamAvailabilityByExamId(selectedExamId, { cache: 'no-store' });
        if (active) {
          setAvailableUsers(response.data || []);
          setAvailabilityError('');
        }
      } catch (error) {
        if (active) setAvailabilityError('Failed to refresh available users. Please try again.');
      } finally {
        pending = false;
        if (active) setAvailabilityLoading(false);
      }
    };
    refresh();
    const interval = setInterval(refresh, 30000);
    window.addEventListener('focus', refresh);
    return () => {
      active = false;
      clearInterval(interval);
      window.removeEventListener('focus', refresh);
    };
  }, [isShowAvailableUsersModalOpen, selectedExamId, availabilityRefresh]);

  const handleToggleRetake = async (userAvailability) => {
    const userId = userAvailability.user_id;
    const examId = selectedExamId;
    const newIsRetake = !userAvailability.is_retake;

    setTogglingRetakeUserId(userId);

    try {
      await examUserRetakeAPI.createExamUserRetake({
        exam_id: examId,
        user_id: userId,
        is_retake: newIsRetake
      });

      // Update the local state to reflect the change
      setAvailableUsers(prev => 
        prev.map(u => 
          u.user_id === userId 
            ? { ...u, is_retake: newIsRetake }
            : u
        )
      );

      console.log(`Retake ${newIsRetake ? 'enabled' : 'disabled'} for user ${userId}`);
    } catch (error) {
      console.error('Error toggling retake:', error);
      alert('Failed to toggle retake status. Please try again.');
    } finally {
      setTogglingRetakeUserId(null);
    }
  };

  const handleToggleClassRetake = async (classTitle, usersInClass, enableRetake) => {
    setTogglingRetakeClassTitle(classTitle);

    try {
      // Send retake requests for all users in the class
      const promises = usersInClass.map(userAvailability => 
        examUserRetakeAPI.createExamUserRetake({
          exam_id: selectedExamId,
          user_id: userAvailability.user_id,
          is_retake: enableRetake
        })
      );

      await Promise.all(promises);

      // Update local state for all users in the class
      const userIds = usersInClass.map(u => u.user_id);
      setAvailableUsers(prev => 
        prev.map(u => 
          userIds.includes(u.user_id)
            ? { ...u, is_retake: enableRetake }
            : u
        )
      );

      console.log(`Retake ${enableRetake ? 'enabled' : 'disabled'} for all ${usersInClass.length} users in class: ${classTitle}`);
    } catch (error) {
      console.error('Error toggling class retake:', error);
      alert('Failed to toggle retake status for class. Please try again.');
    } finally {
      setTogglingRetakeClassTitle(null);
    }
  };

  const handleUserSelection = (user) => {
    setSelectedUsers(prev => {
      const isSelected = prev.find(u => u.id === user.id);
      if (isSelected) {
        return prev.filter(u => u.id !== user.id);
      } else {
        return [...prev, user];
      }
    });
  };

  const filteredMakeAvailableUsers = users.filter(user =>
    [user.first_name, user.last_name, user.email, user.username]
      .some(value => (value || '').toLowerCase().includes(makeAvailableUsersSearchQuery.trim().toLowerCase()))
  );
  const selectedUserIds = new Set(selectedUsers.map(user => user.id));
  const allVisibleUsersSelected = filteredMakeAvailableUsers.length > 0 &&
    filteredMakeAvailableUsers.every(user => selectedUserIds.has(user.id));

  const handleSelectAllUsers = () => {
    const visibleIds = new Set(filteredMakeAvailableUsers.map(user => user.id));
    setSelectedUsers(previous => allVisibleUsersSelected
      ? previous.filter(user => !visibleIds.has(user.id))
      : [...previous, ...filteredMakeAvailableUsers.filter(user => !previous.some(selected => selected.id === user.id))]);
  };

  const handleClassSelection = (classItem) => {
    setSelectedClasses(prev => {
      const isSelected = prev.find(c => c.id === classItem.id);
      if (isSelected) {
        return prev.filter(c => c.id !== classItem.id);
      } else {
        return [...prev, classItem];
      }
    });
  };

  const handleOpenExamTypeModal = () => {
    setIsExamTypeModalOpen(true);
    fetchExamTypes();
    fetchCourses();
  };

  const handleExamTypeInputChange = (e) => {
    const { name, value } = e.target;
    setExamTypeFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleExamTypeFilterChange = (courseId) => {
    setExamTypeFilterCourse(courseId);
    if (courseId === '') {
      setFilteredExamTypes(examTypes);
    } else {
      const filtered = examTypes.filter(examType => examType.course_id === parseInt(courseId));
      setFilteredExamTypes(filtered);
    }
  };

  const handleSubmitExamType = async (e) => {
    e.preventDefault();
    
    try {
      setIsSubmittingExamType(true);
      const submitData = {
        ...examTypeFormData,
        course_id: parseInt(examTypeFormData.course_id)
      };
      
      await examTypeAPI.createExamType(submitData);
      
      // Clear cache to ensure fresh data
      examTypeAPI.clearExamTypeCache();
      examAPI.clearExamCache();
      
      // Reset form
      setExamTypeFormData({
        name: '',
        description: '',
        course_id: ''
      });
      
      // Refresh exam types list
      await fetchExamTypes();
      
      // Re-apply the filter if one is active
      if (examTypeFilterCourse) {
        handleExamTypeFilterChange(examTypeFilterCourse);
      }
      
      // alert('Exam type created successfully!');
      
    } catch (error) {
      console.error('Error creating exam type:', error);
      alert('Failed to create exam type. Please try again.');
    } finally {
      setIsSubmittingExamType(false);
    }
  };

  const resetExamTypeForm = () => {
    setExamTypeFormData({
      name: '',
      description: '',
      course_id: ''
    });
    setExamTypeFilterCourse('');
    setFilteredExamTypes(examTypes);
  };

  const handleCloseExamTypeModal = () => {
    setIsExamTypeModalOpen(false);
    resetExamTypeForm();
  };

  const handleDeleteExamType = async (examTypeId) => {
    if (!window.confirm('Are you sure you want to delete this exam type? This action cannot be undone.')) {
      return;
    }

    try {
      setDeletingExamTypeId(examTypeId);
      await examTypeAPI.deleteExamType(examTypeId);
      
      // Clear cache to ensure fresh data
      examTypeAPI.clearExamTypeCache();
      
      // Refresh the exam types list
      await fetchExamTypes();
      
      // Re-apply the filter if one is active
      if (examTypeFilterCourse) {
        handleExamTypeFilterChange(examTypeFilterCourse);
      }
      
      // alert('Exam type deleted successfully!');
    } catch (error) {
      console.error('Error deleting exam type:', error);
      alert('Failed to delete exam type. Please try again.');
    } finally {
      setDeletingExamTypeId(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setIsSubmitting(true);
      const submitData = {
        ...formData,
        course_id: parseInt(formData.course_id),
        exam_type_id: formData.exam_type_id ? parseInt(formData.exam_type_id) : null,
        total_marks: parseInt(formData.total_marks),
        pass_marks: parseInt(formData.pass_marks),
        duration_minutes: parseInt(formData.duration_minutes),
        is_active: formData.is_active ? 1 : 0
      };
      
      if (isEditing) {
        // Update existing exam
        await examAPI.updateExam(editingExamId, submitData);
      } else {
        // Create new exam
        await examAPI.createExam(submitData);
      }
      
      setIsModalOpen(false);
      resetForm();
      fetchExams();
    } catch (error) {
      console.error(`Error ${isEditing ? 'updating' : 'creating'} exam:`, error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEditExam = (exam) => {
    setIsEditing(true);
    setEditingExamId(exam.id);
    setFormData({
      course_id: exam.course_id ? String(exam.course_id) : '',
      exam_type_id: exam.exam_type_id ? String(exam.exam_type_id) : '',
      title: exam.title || '',
      description: exam.description || '',
      total_marks: exam.total_marks ? String(exam.total_marks) : '',
      pass_marks: exam.pass_marks ? String(exam.pass_marks) : '',
      duration_minutes: exam.duration_minutes ? String(exam.duration_minutes) : '',
      is_active: Boolean(exam.is_active)
    });
    
    // Fetch exam types for the selected course when editing
    if (exam.course_id) {
      fetchExamTypesByCourse(exam.course_id);
    }
    setIsModalOpen(true);
  };

  const handleDeleteExam = async (examId) => {
    if (!window.confirm('Are you sure you want to delete this exam? This action cannot be undone.')) {
      return;
    }

    try {
      setDeletingExamId(examId);
      await examAPI.deleteExam(examId);
      await fetchExams();
      examAPI.clearExamCache();
    } catch (error) {
      console.error('Error deleting exam:', error);
      alert('Failed to delete exam. Please try again.');
    } finally {
      setDeletingExamId(null);
    }
  };

  const handleToggleStatus = async (exam) => {
    try {
      if (exam.is_active) {
        await examAPI.deactivateExam(exam.id);
      } else {
        await examAPI.activateExam(exam.id);
      }
      fetchExams();
    } catch (error) {
      console.error('Error toggling exam status:', error);
      alert('Failed to update exam status. Please try again.');
    }
  };

  const resetForm = () => {
    setFormData({
      course_id: '',
      exam_type_id: '',
      title: '',
      description: '',
      total_marks: '',
      pass_marks: '',
      duration_minutes: '',
      is_active: false
    });
    setCourseExamTypes([]);
    setIsEditing(false);
    setEditingExamId(null);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    resetForm();
  };

  const getCourseTitle = (courseId) => {
    const course = courses.find(c => c.id === courseId);
    return course ? course.title : 'Unknown Course';
  };

  return (
    <div className="max-w-6xl mx-auto p-9">
      <div className="mb-8 border-b border-gray-200 pb-4">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Exams</h1>
            <p className="text-lg text-gray-600">Manage course examinations</p>
          </div>
          <div className="flex space-x-3">
            <button
              onClick={handleOpenExamTypeModal}
              className="px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors"
            >
              + Exam Type
            </button>
            <button
              onClick={() => setIsModalOpen(true)}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
            >
              + Add Exam
            </button>
          </div>
        </div>
      </div>

      <DataTable
        columns={columns}
        data={exams}
        searchKey="title"
        searchPlaceholder="Search exams..."
        loading={loading}
        emptyMessage="No exams found."
      />

      <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
        <form onSubmit={handleSubmit}>
          <ModalHeader>
            <h2 className="text-xl font-semibold">
              {isEditing ? 'Edit Exam' : 'Add New Exam'}
            </h2>
          </ModalHeader>

          <ModalBody className="space-y-4">
            <div>
              <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-1">
                Title *
              </label>
              <Input
                id="title"
                name="title"
                type="text"
                value={formData.title}
                onChange={handleInputChange}
                required
                placeholder="Enter exam title"
              />
            </div>

            <div>
              <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1">
                Description
              </label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                rows={3}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                placeholder="Enter exam description"
              />
            </div>

            <div>
              <label htmlFor="course_id" className="block text-sm font-medium text-gray-700 mb-1">
                Course *
              </label>
              <select
                id="course_id"
                name="course_id"
                value={formData.course_id}
                onChange={handleInputChange}
                required
                disabled={coursesLoading}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed"
              >
                <option value="">
                  {coursesLoading ? 'Loading courses...' : 'Select a course'}
                </option>
                {!coursesLoading && courses.map((course) => (
                  <option key={course.id} value={course.id}>
                    {course.title || `Course ${course.id}`}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label htmlFor="exam_type_id" className="block text-sm font-medium text-gray-700 mb-1">
                Exam Type
              </label>
              <select
                id="exam_type_id"
                name="exam_type_id"
                value={formData.exam_type_id}
                onChange={handleInputChange}
                disabled={!formData.course_id || courseExamTypesLoading}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed"
              >
                <option value="">
                  {!formData.course_id 
                    ? 'Select a course first' 
                    : courseExamTypesLoading 
                    ? 'Loading exam types...' 
                    : 'Select an exam type (optional)'
                  }
                </option>
                {!courseExamTypesLoading && courseExamTypes.map((examType) => (
                  <option key={examType.id} value={examType.id}>
                    {examType.name}
                  </option>
                ))}
              </select>
              {formData.course_id && courseExamTypes.length === 0 && !courseExamTypesLoading && (
                <p className="text-xs text-gray-500 mt-1">
                  No exam types found for this course. You can create one using the "+ Exam Type" button.
                </p>
              )}
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label htmlFor="total_marks" className="block text-sm font-medium text-gray-700 mb-1">
                  Total Marks *
                </label>
                <Input
                  id="total_marks"
                  name="total_marks"
                  type="number"
                  value={formData.total_marks}
                  onChange={handleInputChange}
                  required
                  min="1"
                  placeholder="e.g., 100"
                />
              </div>

              <div>
                <label htmlFor="pass_marks" className="block text-sm font-medium text-gray-700 mb-1">
                  Pass Marks *
                </label>
                <Input
                  id="pass_marks"
                  name="pass_marks"
                  type="number"
                  value={formData.pass_marks}
                  onChange={handleInputChange}
                  required
                  min="1"
                  placeholder="e.g., 60"
                />
              </div>
            </div>

            <div>
              <label htmlFor="duration_minutes" className="block text-sm font-medium text-gray-700 mb-1">
                Duration (minutes) *
              </label>
              <Input
                id="duration_minutes"
                name="duration_minutes"
                type="number"
                value={formData.duration_minutes}
                onChange={handleInputChange}
                required
                min="1"
                placeholder="e.g., 120"
              />
            </div>

            <div className="flex items-center">
              <input
                id="is_active"
                name="is_active"
                type="checkbox"
                checked={formData.is_active}
                onChange={handleInputChange}
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <label htmlFor="is_active" className="ml-2 block text-sm text-gray-700">
                Active exam (students can take this exam)
              </label>
            </div>
          </ModalBody>

          <ModalFooter>
            <Button
              type="button"
              onClick={handleCloseModal}
              className="mr-2 bg-gray-500 hover:bg-gray-600"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting 
                ? (isEditing ? 'Updating...' : 'Creating...') 
                : (isEditing ? 'Update Exam' : 'Create Exam')
              }
            </Button>
          </ModalFooter>
        </form>
      </Modal>

      {/* View Questions Modal */}
      <Modal 
        isOpen={isQuestionsModalOpen} 
        onClose={() => {
          setIsQuestionsModalOpen(false);
          setSelectedExam(null);
          setSelectedExamId(null);
          setExamQuestions([]);
        }}
        className="max-w-4xl"
      >
        <ModalHeader>
          <h2 className="text-xl font-semibold">
            Exam Content - {selectedExam?.title}
          </h2>
          <p className="text-gray-600">
            View and manage quizzes and questions for this exam
          </p>
        </ModalHeader>

        <ModalBody className="max-h-96 overflow-y-auto">
          {questionsLoading ? (
            <div className="text-center py-8">
              <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
              <p className="mt-4 text-gray-600">Loading exam content...</p>
            </div>
          ) : examQuestions.length > 0 ? (
            <div className="space-y-6">
              {/* Quizzes Section */}
              {examQuestions.filter(item => item.quiz_id && item.quiz_id !== 0).length > 0 && (
                <div>
                  <h3 className="text-lg font-semibold text-blue-600 mb-3 border-b border-blue-200 pb-2">
                    Quizzes ({examQuestions.filter(item => item.quiz_id && item.quiz_id !== 0).length})
                  </h3>
                  <div className="space-y-3">
                    {examQuestions
                      .filter(item => item.quiz_id && item.quiz_id !== 0)
                      .map((quiz, index) => (
                      <div key={quiz.id} className="border border-blue-200 rounded-lg p-4 bg-blue-50">
                        <div className="flex items-start justify-between">
                          <div className="flex-1">
                            <div className="flex items-center space-x-2 mb-2">
                              <h4 className="text-lg font-medium text-blue-900">
                                Quiz {index + 1}
                              </h4>
                              <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2 py-1 rounded">
                                Quiz ID: {quiz.quiz_id}
                              </span>
                            </div>
                            
                            <div className="text-sm text-blue-700">
                              <p><strong>Exam Question ID:</strong> {quiz.id}</p>
                              <p><strong>Type:</strong> Complete Quiz</p>
                            </div>
                          </div>
                          
                          <button
                            onClick={() => handleDeleteExamQuestion(quiz.id)}
                            disabled={deletingExamQuestionId === quiz.id}
                            className="p-2 text-red-500 hover:text-red-700 hover:bg-red-100 rounded-full transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                            title="Remove quiz from exam"
                          >
                            {deletingExamQuestionId === quiz.id ? (
                              <div className="animate-spin w-4 h-4 border-2 border-red-500 border-t-transparent rounded-full"></div>
                            ) : (
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                              </svg>
                            )}
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Questions Section */}
              {examQuestions.filter(item => item.question_id && item.question_id !== 0).length > 0 && (
                <div>
                  <h3 className="text-lg font-semibold text-green-600 mb-3 border-b border-green-200 pb-2">
                    Individual Questions ({examQuestions.filter(item => item.question_id && item.question_id !== 0).length})
                  </h3>
                  <div className="space-y-3">
                    {examQuestions
                      .filter(item => item.question_id && item.question_id !== 0)
                      .map((question, index) => (
                      <div key={question.id} className="border border-green-200 rounded-lg p-4 bg-green-50">
                        <div className="flex items-start justify-between">
                          <div className="flex-1">
                            <div className="flex items-center space-x-2 mb-2">
                              <h4 className="text-lg font-medium text-green-900">
                                Question {index + 1}
                              </h4>
                              <span className="bg-green-100 text-green-800 text-xs font-medium px-2 py-1 rounded">
                                Question ID: {question.question_id}
                              </span>
                            </div>
                            
                            <div className="text-sm text-green-700">
                              <p><strong>Exam Question ID:</strong> {question.id}</p>
                              <p><strong>Type:</strong> Individual Question</p>
                              {question.question_text && (
                                <p className="mt-2"><strong>Text:</strong> {question.question_text}</p>
                              )}
                              {question.marks && (
                                <p><strong>Marks:</strong> {question.marks}</p>
                              )}
                            </div>
                          </div>
                          
                          <button
                            onClick={() => handleDeleteExamQuestion(question.id)}
                            disabled={deletingExamQuestionId === question.id}
                            className="p-2 text-red-500 hover:text-red-700 hover:bg-red-100 rounded-full transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                            title="Remove question from exam"
                          >
                            {deletingExamQuestionId === question.id ? (
                              <div className="animate-spin w-4 h-4 border-2 border-red-500 border-t-transparent rounded-full"></div>
                            ) : (
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                              </svg>
                            )}
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="text-center py-8 text-gray-500">
              <svg className="w-16 h-16 mx-auto mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h3 className="text-lg font-medium text-gray-900 mb-2">No Content Found</h3>
              <p>This exam doesn't have any quizzes or questions yet.</p>
              <Button
                onClick={() => {
                  setIsQuestionsModalOpen(false);
                  handleAddQuestion(selectedExam);
                }}
                className="mt-4 bg-green-600 hover:bg-green-700"
              >
                Add First Content
              </Button>
            </div>
          )}
        </ModalBody>

        <ModalFooter>
          <Button
            onClick={() => {
              setIsQuestionsModalOpen(false);
              setSelectedExam(null);
              setSelectedExamId(null);
              setExamQuestions([]);
            }}
            className="mr-2 bg-gray-500 hover:bg-gray-600"
          >
            Close
          </Button>
          <Button
            onClick={() => {
              setIsQuestionsModalOpen(false);
              handleAddQuestion(selectedExam);
            }}
            className="bg-green-600 hover:bg-green-700"
          >
            Add Content
          </Button>
        </ModalFooter>
      </Modal>

      {/* Add Question Modal */}
      <Modal 
        isOpen={isAddQuestionModalOpen} 
        onClose={() => {
          setIsAddQuestionModalOpen(false);
          setSelectedExam(null);
          setSelectedExamId(null);
          setSelectedQuizzes([]);
          setSelectedQuestions([]);
        }}
        className="max-w-6xl mx-auto max-h-[90vh] overflow-hidden flex flex-col"
      >
        <form onSubmit={handleSubmitQuestion}>
          <ModalHeader>
            <h2 className="text-xl font-semibold">
              Add Questions/Quizzes - {selectedExam?.title}
            </h2>
            <p className="text-gray-600">
              Select existing quizzes and questions to add to this exam
            </p>
          </ModalHeader>

          <ModalBody className="flex-1 overflow-y-auto p-6">
            {/* Selected Items Summary */}
            {(selectedQuizzes.length > 0 || selectedQuestions.length > 0) && (
              <div className="mb-4 p-3 bg-blue-50 rounded border border-blue-200 sticky top-0 z-10">
                <div className="text-sm text-blue-700 flex items-center justify-between">
                  <div>
                    <span className="font-medium">{selectedQuizzes.length} quizzes</span> and <span className="font-medium">{selectedQuestions.length} questions</span> selected
                  </div>
                  <div className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">
                    Total: {selectedQuizzes.length + selectedQuestions.length} items
                  </div>
                </div>
              </div>
            )}

            {/* Parallel Layout for Quizzes and Questions */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 min-h-[400px]">
              {/* Quizzes Section */}
              <div className="flex flex-col">
                <div className="flex items-center justify-between mb-3 sticky top-0 bg-white z-10 py-2">
                  <h3 className="text-lg font-medium text-gray-900">Available Quizzes</h3>
                  {quizzesLoading && (
                    <div className="inline-block animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                  )}
                </div>
                
                <div className="flex-1">
                  {quizzesLoading ? (
                    <div className="text-center py-8 text-gray-500 border border-gray-200 rounded">
                      <div className="inline-block animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600 mb-2"></div>
                      <p>Loading quizzes...</p>
                    </div>
                  ) : quizzes.length > 0 ? (
                    <div className="max-h-80 overflow-y-auto border border-gray-200 rounded p-3 space-y-3 scrollbar-thin scrollbar-thumb-blue-300 scrollbar-track-gray-100">
                      {quizzes.map((quiz) => (
                        <div
                          key={quiz.id}
                          className={`p-3 border rounded cursor-pointer transition-colors ${
                            selectedQuizzes.find(q => q.id === quiz.id)
                              ? 'border-blue-500 bg-blue-50'
                              : 'border-gray-200 hover:border-gray-300'
                          }`}
                          onClick={() => handleQuizSelection(quiz)}
                        >
                          <div className="flex items-start justify-between">
                            <div className="flex-1">
                              <h4 className="font-medium text-gray-900 text-sm">{quiz.title}</h4>
                              <p className="text-xs text-gray-500 mt-1">{quiz.description || 'No description'}</p>
                              <div className="flex items-center mt-2 space-x-2">
                                <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">
                                  ID: {quiz.id}
                                </span>
                                {quiz.total_marks && (
                                  <span className="text-xs bg-green-100 text-green-600 px-2 py-1 rounded">
                                    {quiz.total_marks} marks
                                  </span>
                                )}
                              </div>
                            </div>
                            <input
                              type="checkbox"
                              checked={!!selectedQuizzes.find(q => q.id === quiz.id)}
                              onChange={() => handleQuizSelection(quiz)}
                              className="ml-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-8 text-gray-500 border border-gray-200 rounded flex items-center justify-center">
                      <div>
                        <svg className="w-12 h-12 mx-auto mb-2 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        <p>No quizzes available</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Questions Section */}
              <div className="flex flex-col">
                <div className="flex items-center justify-between mb-3 sticky top-0 bg-white z-10 py-2">
                  <h3 className="text-lg font-medium text-gray-900">Available Questions</h3>
                  {questionsDataLoading && (
                    <div className="inline-block animate-spin rounded-full h-4 w-4 border-b-2 border-green-600"></div>
                  )}
                </div>
                
                {/* Search Input */}
                <div className="mb-3">
                  <Input
                    type="text"
                    placeholder="Search questions by text or ID..."
                    value={questionSearchQuery}
                    onChange={(e) => setQuestionSearchQuery(e.target.value)}
                    className="w-full"
                  />
                </div>
                
                <div className="flex-1">
                  {questionsDataLoading ? (
                    <div className="text-center py-8 text-gray-500 border border-gray-200 rounded">
                      <div className="inline-block animate-spin rounded-full h-6 w-6 border-b-2 border-green-600 mb-2"></div>
                      <p>Loading questions...</p>
                    </div>
                  ) : questions.length > 0 ? (
                    <div className="max-h-80 overflow-y-auto border border-gray-200 rounded p-3 space-y-2 scrollbar-thin scrollbar-thumb-green-300 scrollbar-track-gray-100">
                      {questions
                        .filter((question) => {
                          if (!questionSearchQuery) return true;
                          const searchLower = questionSearchQuery.toLowerCase();
                          return (
                            question.id?.toString().includes(searchLower) ||
                            question.text?.toLowerCase().includes(searchLower) ||
                            question.type?.toLowerCase().includes(searchLower)
                          );
                        })
                        .map((question) => (
                        <div
                          key={question.id}
                          className={`p-3 border rounded cursor-pointer transition-colors ${
                            selectedQuestions.find(q => q.id === question.id)
                              ? 'border-green-500 bg-green-50'
                              : 'border-gray-200 hover:border-gray-300'
                          }`}
                          onClick={() => handleQuestionSelection(question)}
                        >
                          <div className="flex items-start justify-between">
                            <div className="flex-1">
                              <div className="font-medium text-gray-900 text-sm max-h-20 overflow-hidden">
                                <div 
                                  dangerouslySetInnerHTML={{ 
                                    __html: question.text?.substring(0, 150) || '' 
                                  }} 
                                />
                                {question.text?.length > 150 && <span>...</span>}
                              </div>
                              <div className="flex items-center mt-2 space-x-2 flex-wrap">
                                <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">
                                  ID: {question.id}
                                </span>
                                <span className="text-xs bg-purple-100 text-purple-600 px-2 py-1 rounded">
                                  {question.type?.replace('_', ' ') || 'Unknown type'}
                                </span>
                                {question.marks && (
                                  <span className="text-xs bg-green-100 text-green-600 px-2 py-1 rounded">
                                    {question.marks} marks
                                  </span>
                                )}
                              </div>
                            </div>
                            <input
                              type="checkbox"
                              checked={!!selectedQuestions.find(q => q.id === question.id)}
                              onChange={() => handleQuestionSelection(question)}
                              className="ml-2 h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-8 text-gray-500 border border-gray-200 rounded flex items-center justify-center">
                      <div>
                        <svg className="w-12 h-12 mx-auto mb-2 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p>No questions available</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </ModalBody>

          <ModalFooter>
            <Button
              type="button"
              onClick={() => {
                setIsAddQuestionModalOpen(false);
                setSelectedExam(null);
                setSelectedExamId(null);
                setSelectedQuizzes([]);
                setSelectedQuestions([]);
              }}
              className="mr-2 bg-gray-500 hover:bg-gray-600"
              disabled={isSubmittingQuestion}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={isSubmittingQuestion || (selectedQuizzes.length === 0 && selectedQuestions.length === 0)}
              className="bg-green-600 hover:bg-green-700"
            >
              {isSubmittingQuestion 
                ? 'Adding...' 
                : `Add ${selectedQuizzes.length + selectedQuestions.length} Items`
              }
            </Button>
          </ModalFooter>
        </form>
      </Modal>

      {/* User Availability Modal */}
      <Modal 
        isOpen={isUserAvailabilityModalOpen} 
        onClose={() => {
          setIsUserAvailabilityModalOpen(false);
          setSelectedExam(null);
          setSelectedExamId(null);
          setSelectedUsers([]);
          setSelectedClasses([]);
          setMakeAvailableUsersSearchQuery('');
        }}
        className="max-w-4xl mx-auto max-h-[90vh] flex flex-col"
      >
        <form onSubmit={handleSubmitUserAvailability} className="flex flex-col min-h-0 max-h-[90vh]">
          <ModalHeader className="shrink-0">
            <h2 className="text-xl font-semibold">
              Make Users Available - {selectedExam?.title}
            </h2>
            <p className="text-gray-600">
              Select users or classes. Class access applies only to currently enrolled students.
            </p>
            <Button type="button" variant="outline" className="mt-2" onClick={() => Promise.all([fetchUsers(), fetchClasses()])} disabled={usersLoading || classesLoading || isSubmittingAvailability}>Refresh users and classes</Button>
          </ModalHeader>

          <ModalBody className="flex flex-col min-h-0 p-6 max-h-[70vh] overflow-y-auto">
            {/* Selected Items Summary */}
            {(selectedUsers.length > 0 || selectedClasses.length > 0) && (
              <div className="mb-4 p-3 bg-orange-50 rounded border border-orange-200 flex-shrink-0">
                <div className="text-sm text-orange-700 flex items-center justify-between">
                  <div>
                    <span className="font-medium">{selectedUsers.length} user(s)</span> and <span className="font-medium">{selectedClasses.length} class(es)</span> selected for exam access
                  </div>
                  <div className="text-xs bg-orange-100 text-orange-800 px-2 py-1 rounded">
                    Total: {selectedUsers.length + selectedClasses.length} items
                  </div>
                </div>
              </div>
            )}

            {/* Parallel Layout for Users and Classes */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 shrink-0">
              {/* Users Section */}
              <div className="flex flex-col h-full min-h-0">
                <div className="flex items-center justify-between mb-3 flex-shrink-0">
                  <h3 className="text-lg font-medium text-gray-900">Available Users ({filteredMakeAvailableUsers.length})</h3>
                  <Button type="button" variant="outline" onClick={handleSelectAllUsers} disabled={usersLoading || isSubmittingAvailability || !filteredMakeAvailableUsers.length}>
                    {allVisibleUsersSelected ? 'Deselect All' : 'Select All'}
                  </Button>
                  {usersLoading && (
                    <div className="inline-block animate-spin rounded-full h-4 w-4 border-b-2 border-orange-600"></div>
                  )}
                </div>

                {/* Search Input */}
                <div className="mb-3 flex-shrink-0">
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Search users..."
                      value={makeAvailableUsersSearchQuery}
                      onChange={(e) => setMakeAvailableUsersSearchQuery(e.target.value)}
                      className="w-full pl-10 text-sm"
                    />
                    <svg
                      className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                  </div>
                </div>
                
                <div className="flex-1 min-h-0 overflow-hidden">
                  {usersLoading ? (
                    <div className="text-center py-8 text-gray-500 border border-gray-200 rounded">
                      <div className="inline-block animate-spin rounded-full h-6 w-6 border-b-2 border-orange-600 mb-2"></div>
                      <p>Loading users...</p>
                    </div>
                  ) : filteredMakeAvailableUsers.length > 0 ? (
                    <div className="h-full max-h-96 overflow-y-auto border border-gray-200 rounded p-3 space-y-2 scrollbar-thin scrollbar-thumb-orange-300 scrollbar-track-gray-100">
                      {filteredMakeAvailableUsers.map((user) => (
                        <div
                          key={user.id}
                          className={`p-3 border rounded cursor-pointer transition-colors ${
                            selectedUsers.find(u => u.id === user.id)
                              ? 'border-orange-500 bg-orange-50'
                              : 'border-gray-200 hover:border-gray-300'
                          }`}
                          onClick={() => handleUserSelection(user)}
                        >
                          <div className="flex items-start justify-between">
                            <div className="flex-1">
                              <h4 className="font-medium text-gray-900 text-sm">
                                {user.first_name} {user.last_name}
                              </h4>
                              <p className="text-xs text-gray-500 mt-1">{user.email}</p>
                              <div className="flex items-center mt-2 space-x-2 flex-wrap">
                                <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">
                                  ID: {user.id}
                                </span>
                                <span className="text-xs bg-blue-100 text-blue-600 px-2 py-1 rounded">
                                  {user.role || 'User'}
                                </span>
                                {user.username && (
                                  <span className="text-xs bg-purple-100 text-purple-600 px-2 py-1 rounded">
                                    @{user.username}
                                  </span>
                                )}
                              </div>
                            </div>
                            <input
                              type="checkbox"
                              checked={!!selectedUsers.find(u => u.id === user.id)}
                              onClick={event => event.stopPropagation()}
                              onChange={() => handleUserSelection(user)}
                              className="ml-2 h-4 w-4 text-orange-600 focus:ring-orange-500 border-gray-300 rounded"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-8 text-gray-500 border border-gray-200 rounded h-full flex items-center justify-center">
                      <div>
                        <svg className="w-12 h-12 mx-auto mb-2 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                        </svg>
                        <p>{makeAvailableUsersSearchQuery ? 'No users match your search' : 'No users available'}</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Classes Section */}
              <div className="flex flex-col min-h-0">
                <div className="flex items-center justify-between mb-3 shrink-0">
                  <h3 className="text-lg font-medium text-gray-900">Available Classes</h3>
                  {classesLoading && (
                    <div className="inline-block animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                  )}
                </div>
                
                <div className="flex-1 min-h-0">
                  {classesLoading ? (
                    <div className="text-center py-8 text-gray-500 border border-gray-200 rounded">
                      <div className="inline-block animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600 mb-2"></div>
                      <p>Loading classes...</p>
                    </div>
                  ) : classes.length > 0 ? (
                    <div className="max-h-96 overflow-y-auto border border-gray-200 rounded p-3 space-y-2">
                      {classes.map((classItem) => (
                        <div
                          key={classItem.id}
                          className={`p-3 border rounded cursor-pointer transition-colors ${
                            selectedClasses.find(c => c.id === classItem.id)
                              ? 'border-blue-500 bg-blue-50'
                              : 'border-gray-200 hover:border-gray-300'
                          }`}
                          onClick={() => handleClassSelection(classItem)}
                        >
                          <div className="flex items-start justify-between">
                            <div className="flex-1">
                              <h4 className="font-medium text-gray-900 text-sm">
                                {classItem.name || classItem.title || `Class ${classItem.id}`}
                              </h4>
                              <p className="text-xs text-gray-500 mt-1">{classItem.description || classItem.class_code || 'No description'}</p>
                              <div className="flex items-center mt-2 space-x-2 flex-wrap">
                                <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">
                                  ID: {classItem.id}
                                </span>
                                {classItem.class_code && (
                                  <span className="text-xs bg-green-100 text-green-600 px-2 py-1 rounded">
                                    Code: {classItem.class_code}
                                  </span>
                                )}
                                {classItem.course_id && (
                                  <span className="text-xs bg-purple-100 text-purple-600 px-2 py-1 rounded">
                                    Course: {classItem.course_id}
                                  </span>
                                )}
                              </div>
                            </div>
                            <input
                              type="checkbox"
                              checked={!!selectedClasses.find(c => c.id === classItem.id)}
                              onClick={event => event.stopPropagation()}
                              onChange={() => handleClassSelection(classItem)}
                              className="ml-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-8 text-gray-500 border border-gray-200 rounded h-full flex items-center justify-center">
                      <div>
                        <svg className="w-12 h-12 mx-auto mb-2 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                        </svg>
                        <p>No classes available</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </ModalBody>

          <ModalFooter className="shrink-0">
            <Button
              type="button"
              onClick={() => {
                setIsUserAvailabilityModalOpen(false);
                setSelectedExam(null);
                setSelectedExamId(null);
                setSelectedUsers([]);
                setSelectedClasses([]);
              }}
              className="mr-2 bg-gray-500 hover:bg-gray-600"
              disabled={isSubmittingAvailability}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={isSubmittingAvailability || (selectedUsers.length === 0 && selectedClasses.length === 0)}
              className="bg-orange-600 hover:bg-orange-700"
            >
              {isSubmittingAvailability 
                ? 'Making Available...' 
                : `Make Available to ${selectedUsers.length + selectedClasses.length} Item(s)`
              }
            </Button>
          </ModalFooter>
        </form>
      </Modal>

      {/* Show Available Users Modal */}
      <Modal 
        isOpen={isShowAvailableUsersModalOpen} 
        onClose={() => {
          setIsShowAvailableUsersModalOpen(false);
          setSelectedExam(null);
          setSelectedExamId(null);
          setAvailableUsers([]);
          setAvailableUsersSearchQuery('');
          setAvailableUsersClassFilter('');
        }}
        className="max-w-4xl mx-auto max-h-[90vh] flex flex-col"
      >
        <ModalHeader>
          <h2 className="text-xl font-semibold">
            Available Users - {selectedExam?.title}
          </h2>
          <p className="text-gray-600">
            Users who are currently allowed to take this exam
          </p>
        </ModalHeader>

        <ModalBody className="flex flex-col p-6 max-h-[70vh] overflow-hidden">
          {/* Search and Filter Row */}
          <div className="mb-4 flex-shrink-0 grid grid-cols-1 md:grid-cols-2 gap-3">
            <div className="relative">
              <Input
                type="text"
                placeholder="Search by username..."
                value={availableUsersSearchQuery}
                onChange={(e) => setAvailableUsersSearchQuery(e.target.value)}
                className="w-full pl-10"
              />
              <svg
                className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
            <select
              value={availableUsersClassFilter}
              onChange={(e) => setAvailableUsersClassFilter(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
            >
              <option value="">All Classes</option>
              {[...new Set(availabileUsers.map(u => u.class_title).filter(Boolean))].map((classTitle) => (
                <option key={classTitle} value={classTitle}>
                  {classTitle}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-3 flex items-center gap-3 shrink-0">
            <Button type="button" variant="outline" disabled={availabilityLoading} onClick={() => setAvailabilityRefresh(value => value + 1)}>Refresh</Button>
            <span className="text-sm text-gray-500">{availabilityLoading ? 'Refreshing...' : 'Updates automatically every 30 seconds'}</span>
          </div>
          {availabilityError && <p role="alert" className="text-red-600 mb-3">{availabilityError}</p>}

          {/* Available Users Count */}
          <div className="mb-4 p-3 bg-green-50 rounded border border-green-200 flex-shrink-0">
            <div className="text-sm text-green-700 flex items-center justify-between">
              <div>
                <span className="font-medium">
                  {availabileUsers.filter(u => 
                    (u.user?.username || '').toLowerCase().includes(availableUsersSearchQuery.toLowerCase()) &&
                    (availableUsersClassFilter === '' || u.class_title === availableUsersClassFilter)
                  ).length} user(s)
                </span> {(availableUsersSearchQuery || availableUsersClassFilter) ? 'matching filters' : 'available to take this exam'}
              </div>
              <div className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded">
                Total: {availabileUsers.length} users
              </div>
            </div>
          </div>

          {/* Available Users List - Grouped by Class */}
          <div className="flex-1 min-h-0 overflow-hidden">
            {availabileUsers.filter(u => 
              (u.user?.username || '').toLowerCase().includes(availableUsersSearchQuery.toLowerCase()) &&
              (availableUsersClassFilter === '' || u.class_title === availableUsersClassFilter)
            ).length > 0 ? (
              <div className="h-full max-h-96 overflow-y-auto border border-gray-200 rounded p-3 space-y-4 scrollbar-thin scrollbar-thumb-green-300 scrollbar-track-gray-100">
                {/* Group users by class_title */}
                {Object.entries(
                  availabileUsers
                    .filter(u => (u.user?.username || '').toLowerCase().includes(availableUsersSearchQuery.toLowerCase()) &&
                      (availableUsersClassFilter === '' || u.class_title === availableUsersClassFilter))
                    .reduce((groups, userAvailability) => {
                      const classTitle = userAvailability.class_title || 'No Class Assigned';
                      if (!groups[classTitle]) {
                        groups[classTitle] = [];
                      }
                      groups[classTitle].push(userAvailability);
                      return groups;
                    }, {})
                ).map(([classTitle, usersInClass]) => (
                  <div key={classTitle} className="border border-gray-200 rounded-lg overflow-hidden">
                    {/* Class Header */}
                    <div className="bg-blue-50 border-b border-blue-200 px-4 py-2">
                      <div className="flex items-center justify-between">
                        <h4 className="font-semibold text-blue-900 text-sm">
                          {classTitle}
                        </h4>
                        <div className="flex items-center space-x-2">
                          {(() => {
                            const allHaveRetake = usersInClass.every(u => u.is_retake);
                            const someHaveRetake = usersInClass.some(u => u.is_retake);
                            return (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleToggleClassRetake(classTitle, usersInClass, !allHaveRetake);
                                }}
                                disabled={togglingRetakeClassTitle === classTitle}
                                className={`px-2 py-1 text-xs font-medium rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
                                  allHaveRetake
                                    ? 'bg-red-100 text-red-700 hover:bg-red-200'
                                    : 'bg-orange-100 text-orange-700 hover:bg-orange-200'
                                }`}
                                title={allHaveRetake ? 'Disable retake for all students' : 'Enable retake for all students'}
                              >
                                {togglingRetakeClassTitle === classTitle ? (
                                  <span className="flex items-center">
                                    <div className="animate-spin w-3 h-3 border-2 border-current border-t-transparent rounded-full mr-1"></div>
                                    Processing...
                                  </span>
                                ) : allHaveRetake ? (
                                  'Disable All Retakes'
                                ) : someHaveRetake ? (
                                  'Enable All Retakes'
                                ) : (
                                  'Allow All Retakes'
                                )}
                              </button>
                            );
                          })()}
                          <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded">
                            {usersInClass.length} user(s)
                          </span>
                        </div>
                      </div>
                    </div>
                    {/* Users in this class */}
                    <div className="p-2 space-y-2 bg-white">
                      {usersInClass.map((userAvailability) => (
                        <div
                          key={userAvailability.id}
                          className="p-3 border border-green-200 rounded bg-green-50"
                        >
                          <div className="flex items-start justify-between">
                            <div className="flex-1">
                              <h4 className="font-medium text-gray-900 text-sm">
                                Username: {userAvailability.user?.username}
                              </h4>
                              <div className="flex items-center mt-2 space-x-2 flex-wrap">
                                <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">
                                  User ID: {userAvailability.user_id}
                                </span>
                                <span className="text-xs bg-purple-100 text-purple-600 px-2 py-1 rounded">
                                  Class ID: {userAvailability.class_id}
                                </span>
                                {userAvailability.created_at && (
                                  <span className="text-xs bg-blue-100 text-blue-600 px-2 py-1 rounded">
                                    Added: {new Date(userAvailability.created_at).toLocaleDateString()}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="ml-2 flex items-center space-x-2">
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleToggleRetake(userAvailability);
                                }}
                                disabled={togglingRetakeUserId === userAvailability.user_id}
                                className={`px-2 py-1 text-xs font-medium rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
                                  userAvailability.is_retake
                                    ? 'bg-red-100 text-red-700 hover:bg-red-200'
                                    : 'bg-orange-100 text-orange-700 hover:bg-orange-200'
                                }`}
                                title={userAvailability.is_retake ? 'Disable retake' : 'Enable retake'}
                              >
                                {togglingRetakeUserId === userAvailability.user_id ? (
                                  <span className="flex items-center">
                                    <div className="animate-spin w-3 h-3 border-2 border-current border-t-transparent rounded-full mr-1"></div>
                                    ...
                                  </span>
                                ) : userAvailability.is_retake ? (
                                  'Disable Retake'
                                ) : (
                                  'Allow Retake'
                                )}
                              </button>
                              <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
                                Available
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-8 text-gray-500 border border-gray-200 rounded h-full flex items-center justify-center">
                <div>
                  <svg className="w-12 h-12 mx-auto mb-2 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                  </svg>
                  <h3 className="text-lg font-medium text-gray-900 mb-2">No Available Users</h3>
                  <p>No users are currently available to take this exam.</p>
                </div>
              </div>
            )}
          </div>
        </ModalBody>

        <ModalFooter>
          <Button
            onClick={() => {
              setIsShowAvailableUsersModalOpen(false);
              setSelectedExam(null);
              setSelectedExamId(null);
              setAvailableUsers([]);
              setAvailableUsersSearchQuery('');
              setAvailableUsersClassFilter('');
            }}
            className="mr-2 bg-gray-500 hover:bg-gray-600"
          >
            Close
          </Button>
          <Button
            onClick={() => {
              setIsShowAvailableUsersModalOpen(false);
              handleMakeUserAvailable(selectedExam);
            }}
            className="bg-green-600 hover:bg-green-700"
          >
            Add More Users
          </Button>
        </ModalFooter>
      </Modal>

      {/* Exam Type Modal */}
      <Modal 
        isOpen={isExamTypeModalOpen} 
        onClose={handleCloseExamTypeModal}
        className="max-w-6xl mx-auto max-h-[90vh] flex flex-col"
      >
        <ModalHeader>
          <h2 className="text-xl font-semibold">
            Exam Types Management
          </h2>
          <p className="text-gray-600">
            Create new exam types and view existing ones by course
          </p>
        </ModalHeader>

        <ModalBody className="flex-1 overflow-hidden p-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 h-full">
            {/* Create Exam Type Section */}
            <div className="flex flex-col">
              <h3 className="text-lg font-medium text-gray-900 mb-4">Create New Exam Type</h3>
              
              <form onSubmit={handleSubmitExamType} className="space-y-4">
                <div>
                  <label htmlFor="examTypeName" className="block text-sm font-medium text-gray-700 mb-1">
                    Name *
                  </label>
                  <Input
                    id="examTypeName"
                    name="name"
                    type="text"
                    value={examTypeFormData.name}
                    onChange={handleExamTypeInputChange}
                    required
                    placeholder="e.g., Final Exam, Midterm, Quiz"
                  />
                </div>

                <div>
                  <label htmlFor="examTypeDescription" className="block text-sm font-medium text-gray-700 mb-1">
                    Description
                  </label>
                  <textarea
                    id="examTypeDescription"
                    name="description"
                    value={examTypeFormData.description}
                    onChange={handleExamTypeInputChange}
                    rows={3}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent resize-none"
                    placeholder="Enter exam type description"
                  />
                </div>

                <div>
                  <label htmlFor="examTypeCourse" className="block text-sm font-medium text-gray-700 mb-1">
                    Course *
                  </label>
                  <select
                    id="examTypeCourse"
                    name="course_id"
                    value={examTypeFormData.course_id}
                    onChange={handleExamTypeInputChange}
                    required
                    disabled={coursesLoading}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed"
                  >
                    <option value="">
                      {coursesLoading ? 'Loading courses...' : 'Select a course'}
                    </option>
                    {!coursesLoading && courses.map((course) => (
                      <option key={course.id} value={course.id}>
                        {course.title || `Course ${course.id}`}
                      </option>
                    ))}
                  </select>
                </div>

                <Button
                  type="submit"
                  disabled={isSubmittingExamType}
                  className="w-full bg-purple-600 hover:bg-purple-700"
                >
                  {isSubmittingExamType ? 'Creating...' : 'Create Exam Type'}
                </Button>
              </form>
            </div>

            {/* View Exam Types Section */}
            <div className="flex flex-col h-full">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-medium text-gray-900">Existing Exam Types</h3>
                {examTypesLoading && (
                  <div className="inline-block animate-spin rounded-full h-4 w-4 border-b-2 border-purple-600"></div>
                )}
              </div>
              
              {/* Course Filter */}
              <div className="mb-4">
                <label htmlFor="courseFilter" className="block text-sm font-medium text-gray-700 mb-1">
                  Filter by Course
                </label>
                <select
                  id="courseFilter"
                  value={examTypeFilterCourse}
                  onChange={(e) => handleExamTypeFilterChange(e.target.value)}
                  disabled={coursesLoading}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed"
                >
                  <option value="">All Courses</option>
                  {!coursesLoading && courses.map((course) => (
                    <option key={course.id} value={course.id}>
                      {course.title || `Course ${course.id}`}
                    </option>
                  ))}
                </select>
              </div>
              
              <div className="flex-1 min-h-0">
                {examTypesLoading ? (
                  <div className="text-center py-8 text-gray-500 border border-gray-200 rounded">
                    <div className="inline-block animate-spin rounded-full h-6 w-6 border-b-2 border-purple-600 mb-2"></div>
                    <p>Loading exam types...</p>
                  </div>
                ) : filteredExamTypes.length > 0 ? (
                  <div className="h-full max-h-96 overflow-y-auto border border-gray-200 rounded p-3 space-y-3 scrollbar-thin scrollbar-thumb-purple-300 scrollbar-track-gray-100">
                    {filteredExamTypes.map((examType) => (
                      <div
                        key={examType.id}
                        className="p-4 border border-purple-200 rounded-lg bg-purple-50"
                      >
                        <div className="flex items-start justify-between">
                          <div className="flex-1">
                            <h4 className="font-medium text-purple-900 text-sm mb-2">
                              {examType.name}
                            </h4>
                            
                            {examType.description && (
                              <p className="text-xs text-purple-700 mb-2">
                                {examType.description}
                              </p>
                            )}
                            
                            <div className="flex items-center space-x-2 flex-wrap">
                              <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">
                                ID: {examType.id}
                              </span>
                              <span className="text-xs bg-purple-100 text-purple-600 px-2 py-1 rounded">
                                Course: {getCourseTitle(examType.course_id)}
                              </span>
                              {examType.created_at && (
                                <span className="text-xs bg-blue-100 text-blue-600 px-2 py-1 rounded">
                                  Created: {new Date(examType.created_at).toLocaleDateString()}
                                </span>
                              )}
                            </div>
                          </div>
                          
                          <button
                            onClick={() => handleDeleteExamType(examType.id)}
                            disabled={deletingExamTypeId === examType.id}
                            className="ml-3 p-2 text-red-500 hover:text-red-700 hover:bg-red-100 rounded-full transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                            title="Delete exam type"
                          >
                            {deletingExamTypeId === examType.id ? (
                              <div className="animate-spin w-4 h-4 border-2 border-red-500 border-t-transparent rounded-full"></div>
                            ) : (
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                              </svg>
                            )}
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-8 text-gray-500 border border-gray-200 rounded h-full flex items-center justify-center">
                    <div>
                      <svg className="w-12 h-12 mx-auto mb-2 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      <p>
                        {examTypeFilterCourse ? 'No exam types found for selected course' : 'No exam types found'}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </ModalBody>

        <ModalFooter>
          <Button
            onClick={handleCloseExamTypeModal}
            className="bg-gray-500 hover:bg-gray-600"
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Exams;
